const colors = {
  black: 'rgb(0, 0, 0)',
  white: 'rgb(255, 255, 255)',
  white50: 'rgba(255, 255, 255, 0.5)',
  gray: 'rgb(204, 204, 204)',
  lighterGray: 'rgb(244, 245, 246)',
  lightGray: 'rgb(230, 230, 230)',
  mediumGray: 'rgb(155, 155, 155)',
  mediumGray2: 'rgb(129, 129, 129)',
  darkGray: 'rgb(51, 51, 51)',
  blue: 'rgb(70, 152, 202)',
  lightBlue: 'rgb(209, 231, 236)',
  darkBlue: 'rgb(113, 134, 140)',
  green: 'rgb(116, 165, 74)',
  lightGreen: 'rgb(232, 236, 226)',
  darkGreen: 'rgb(136,144,129)',
  darkPurple: 'rgb(66,44,64)',
  lightPurple: 'rgb(180, 156, 185)',
  red: 'rgb(200, 49, 69)',
  lighterRed: ' rgb(222, 194, 194)',
  darkRed: ' rgb(95, 39, 39)',
  darkBrown: 'rgb(95,66,64)',
  darkerBrown: 'rgb(71, 64, 64)',
  lightBrown: 'rgb(229,222,217)',
  lightYellow: 'rgb(255, 246, 233)',

  brightOrange: '#e68532',
  brightBlue: '#3b91a4',
  brightYellow: '#ffd700',
  brightGreen: '#7b9f34',
  brightBrown: '#86482c',
};

const breakPoints = {
  xs: 0,
  sm: 600,
  md: 840,
  lg: 1280,
  xl: 1920,
};

const brandColors = {
  black: '#0f0f0f',
  white: '#ffffff',
};

const textColors = {
  bodyText: '#ffffff',
  mutedText: '#7D7D7D',
  disabledText: '#B9B9B9',
  lightText: colors.white,
};

const textFontFamilies = {
  fontTypography: 'MercuryDisplay, sans-serif',
  fontBody1: 'MercuryDisplay, sans-serif',
  fontBody2: 'MercuryDisplay, sans-serif',
  fontHeadings: 'TradeGothic, sans-serif',
  fontBotton: 'MercuryDisplay, sans-serif',
};

const textFontSizesMobile = {
  fontSizeLeadText: '1.125rem',
  fontSizeTypography: '0.938rem',
  fontSizeButton: '0.875rem',
  fontSizeBody1: '0.938rem',
  fontSizeBody2: '0.813rem',
  fontSizeH1: '1.875rem',
  fontSizeH2: '1.5rem',
  fontSizeH3: '1.188rem',
  fontSizeH4: '1.125rem',
};
const textFontSizesDesktop = {
  fontSizeLeadText: '1.188rem',
  fontSizeTypography: '1rem',
  fontSizeButton: '1rem',
  fontSizeBody1: '1rem',
  fontSizeBody2: '0.813rem',
  fontSizeH1: '2.75rem',
  fontSizeH2: '2rem',
  fontSizeH3: '1.5rem',
  fontSizeH4: '1.125rem',
};
const textFontWeight = {
  typography: 'normal',
  button: '600',
  body1: 'normal',
  body2: 'normal',
  h1: '500',
  h2: '500',
  h3: '500',
  h4: '500',
};
const textLineHeightsMobile = {
  lineHeightLeadText: '1.5',
  lineHeightQuote: '1.47',
  lineHeightBody1: '1.47',
  lineHeightBody2: '1.54',
  lineHeightHeadings: 'normal',
};

const textLineHeightsDesktop = {
  lineHeightLeadText: '1.58',
  lineHeightQuote: '1.5',
  lineHeightBody1: '1.5',
  lineHeightBody2: '1.54',
  lineHeightHeadings: 'normal',
};

const typography = {
  h1: {
    marginBottom: '2.5rem',
  },
  h2: {
    marginBottom: '1.75rem',
    textTransform: 'none',
  },
  h3: {
    marginBottom: '1rem',
  },
  h4: {
    marginBottom: '1rem',
  },
  h5: {
    marginBottom: '1rem',
  },
  h6: {
    marginBottom: '1rem',
  },
};

const pageTemplates = {
  landingPage: {
    mobile: {
      paddingTop: 5, // => value x 8px
    },
    desktop: {
      paddingTop: 7, // => value x 8px
    },
  },
  otherPageTemplates: {
    mobile: {
      paddingTop: 14, // => value x 8px
    },
    desktop: {
      paddingTop: 15, // => value x 8px
    },
  },
};

const linkColors = {
  link: '#ffadad',
  linkHover: '#bd8080',
  linkPressed: '#bd8080',
};

const iconColors = {
  iconColor: '#ffffff',
};

const hr = {};

const backgroundColors = {
  paper: '#0f0f0f',
  grayLight: '#F0F0F0F0',
  grayDark: '#373737',
  goldLight: '#F1E8E2',
  overlay: 'rgba(50,50,50,0.7)',
};

const formColors = {
  inputBorder: '#B4B4B4',
  inputBackground: '#F0F0F0',
  inputActiveBackground: '#F0F0F0',
  inputActiveBorder: '#ffadad',
  inputBorderRadius: '0',
};

const primaryButtonColors = {
  primaryButtonBackground: '#F0F0F0',
  primaryButtonBackgroundGradient: 'none',
  primaryButtonHoveredBackground: '#ffadad',
  primaryButtonPressedBackground: '#ffadad',
  primaryButtonDisabledBackground: 'rgba(247, 101, 101, 0.4)',
  primaryButtonContents: '#0f0f0f',
};
const secondaryButtonColors = {
  secondaryButtonBackground: '#ffadad',
  secondaryButtonHoveredBackground: '#bd8080',
  secondaryButtonPressedBackground: '#bd8080',
  secondaryButtonDisabledBackground: 'rgba(247, 101, 101, 0.4)',
  secondaryButtonContents: '#0f0f0f',
};

const outlinedButtonColors = {
  outlinedButton: '#ffadad',
  outlinedButtonHovered: brandColors.black,
  outlinedButtonPressed: '#ffadad',
  outlinedButtonDisabled: 'rgba(247, 101, 101, 0.4)',
  outlinedButtonHoveredBackground: brandColors.black,
};

const buttonSettings = {
  buttonPaddingDesktop: '8px 14px',
  buttonPaddingMobile: '12px 20px',
  borderRadius: '4px',
  textTransform: 'inherit',
};

const notificationColors = {
  infoBackground: '#E7EEF8',
  successBackground: '#E9F8EA',
  warningBackground: '#FDF2E9',
  errorBackground: '#F6E6E6',

  infoContents: '#3D68A8',
  successContents: '#218E2C',
  warningContents: '#E8770E',
  errorContents: '#D71717',
};

const header = {
  text: colors.pirateGold,
  background: brandColors.black,
  minHeight: '72px',
  paddingYDesktop: '60px',
  navigation: {
    activeLink: linkColors.linkPressed,
    activeLinkBorder: 'none',
    hoverText: linkColors.linkHover,
    subMenuBackground: colors.white,
    subMenuBulletPoints: colors.white,
  },
  border: {
    style: 'solid',
    bottomWidth: '3px',
  },
  icons: {
    color: colors.white,
    backgroundColor: colors.black,
  },
};

const footer = {
  border: {
    color: 'transparent',
    width: '3px',
  },
  divider: brandColors.black,
  text: colors.white,
  background: brandColors.black,
  logoBarBackground: brandColors.black,
  padding: {
    bottom: '50px',
  },
};

const accordion = {
  backgroundColor: backgroundColors.grayDark,
  borderRadius: '12px',
  color: brandColors.white,
  flexDirection: 'row',
  titleFontSize: '1.125rem',
  hover: {
    backgroundColor: backgroundColors.overlay,
    color: brandColors.white,
  },
  expandIcon: {
    backgroundColor: 'inherit',
    hover: {
      backgroundColor: 'inherit',
    },
  },
  padding: {
    left: '12px',
    right: '8px',
  },
};

const languageSelector = {
  border: {
    color: formColors.inputBorder,
    width: '2px',
  },
  margin: '0',
};

const table = {
  border: `solid 1px ${brandColors.white}`,
  borderRadius: '4px',
  head: {
    backgroundColor: backgroundColors.overlay,
    color: colors.white,
  },
  row: {
    backgroundColor: backgroundColors.grayDark,
    even: {
      backgroundColor: backgroundColors.grayDark,
    },
  },
  cell: {
    border: `solid 1px ${brandColors.white}`,
  },
};

const category = {
  outlined: {
    background: backgroundColors.grayLight,
    text: linkColors.link,
  },
  text: linkColors.link,
  hoverText: linkColors.linkHover,
};

const mobileNavigation = {
  text: linkColors.link,
  icon: textColors.bodyText,
  xIconBackground: backgroundColors.grayDark,
  logoBarBottomBorder: backgroundColors.grayDark,
  navigationElementBorder: backgroundColors.grayDark,
  subNavigationTitleBackground: backgroundColors.grayDark,
  subNavigationTitleColor: colors.white,
  drawer: {
    paper: {
      backgroundColors: backgroundColors.paper,
      widthDesktop: '350px',
    },
  },
};

export const valhallaPrimaryTheme = {
  colors,
  breakPoints,
  brandColors,
  textColors,
  textFontFamilies,
  textFontSizesMobile,
  textFontSizesDesktop,
  textFontWeight,
  textLineHeightsMobile,
  textLineHeightsDesktop,
  typography,
  pageTemplates,
  linkColors,
  iconColors,
  backgroundColors,
  formColors,
  primaryButtonColors,
  secondaryButtonColors,
  outlinedButtonColors,
  buttonSettings,
  notificationColors,
  header,
  footer,
  accordion,
  languageSelector,
  table,
  category,
  mobileNavigation,
  hr,
};
